import { Detection } from '@mediapipe/face_detection';
import { GpuBuffer } from '@mediapipe/selfie_segmentation';
import { findFace } from './face-recognition';
import { faceSegment } from './face-segmentation';

function drawImageInContext(ctx: CanvasRenderingContext2D, img: HTMLCanvasElement, pos: any) {
	let widthRatio = pos.width /img.width;

	// drawBorders(ctx, img, pos);
	let imgCenterW = img.width/2;
	let posCenterW = pos.width/2;
	let imgCenterH = img.height/2;
	let posCenterH = img.height/2;

	let diffW = imgCenterW - posCenterW;
	let diffH = imgCenterH - posCenterH;

	ctx.globalCompositeOperation = 'source-over'; // Reset to default mode
	ctx.drawImage(img, pos.x, pos.y-diffH, pos.width, img.height * widthRatio); // Draw the original image

}

function drawBorders(ctx: CanvasRenderingContext2D, img: HTMLCanvasElement, pos: any){
	let widthRatio = pos.width / img.width;
	let offset = 4;

	// Step 1: Draw the image in red to simulate the border (offset it slightly)
	ctx.globalCompositeOperation = 'source-over'; // Reset to default mode
	// draw borders
	ctx.drawImage(img, pos.x - offset, pos.y - offset, pos.width, img.height*widthRatio); 
	ctx.drawImage(img, pos.x + offset, pos.y - offset, pos.width, img.height*widthRatio); 
	ctx.drawImage(img, pos.x - offset, pos.y + offset, pos.width, img.height*widthRatio); 
	ctx.drawImage(img, pos.x + offset, pos.y + offset, pos.width, img.height*widthRatio); 

	// Step 2: Set the fill style to red (border color)
	ctx.globalCompositeOperation = 'source-atop'; // Keep only the border color (avoid blending)
	ctx.fillStyle = "white";
	ctx.fillRect(pos.x - offset, pos.y - offset, pos.width+offset*2, img.height*widthRatio+offset*2); // Fill the entire canvas with red
}

interface Template {
	url: string,
	p1: any,
	p2: any
}

let zendaya: Template = {
	url: "/img/zendaya.webp",
	p1: {
		x: 240,
		y: 180,
		width: 300,
	},
	p2: {
		x: 500,
		y: 80,
		width: 300,
	}
}

let templates: Template[] = [
	{
		url: "/img/thor.png",
		p1: {
			x: 87,
			y: 112,
			width: 51,
			height: 58,
		},
		p2: {
			x: 109,
			y: 42,
			width: 52,
			height: 60,
		}
	},
	{
		url: "/img/joker.png",
		p1: {
			x: 153,
			y: 66,
			width: 55,
			height: 64,
		},
		p2: {
			x: 81,
			y: 56,
			width: 59,
			height: 65,
		}
	},
	{
		url: "/img/messi.png",
		p1: {
			x: 73,
			y: 83,
			width: 64,
			height: 73,
		},
		p2: {
			x: 120,
			y: 67,
			width: 65,
			height: 79,
		}
	},
	{
		url: "/img/spiderman.png",
		p1: {
			x: 91,
			y: 70,
			width: 48,
			height: 47,
		},
		p2: {
			x: 165,
			y: 106,
			width: 53,
			height: 63,
		}
	},
	{
		url: "/img/titanic.png",
		p1: {
			x: 160,
			y: 75,
			width: 48,
			height: 51,
		},
		p2: {
			x: 95,
			y: 73,
			width: 58,
			height: 51,
		}
	},
	{
		url: "/img/shrek.png",
		p1: {
			x: 182,
			y: 116,
			width: 63,
			height: 60,
		},
		p2: {
			x: 67,
			y: 55,
			width: 90,
			height: 101,
		}
	},
	{	
		url: "/img/cristiano.png",
		p1: {
			x: 56,
			y: 90,
			width: 58,
			height: 67,
		},
		p2: {
			x: 123,
			y: 46,
			width: 65,
			height: 73,
		}
	},
	{
		url: "/img/spiderman-2.png",
		p1: {
			x: 87,
			y: 29,
			width: 58,
			height: 66,
		},
		p2: {
			x: 142,
			y: 47,
			width: 58,
			height: 66,
		}
	},
	{
		url: "/img/alicia.png",
		p1: {
			x: 203,
			y: 112,
			width: 38,
			height: 36,
		},
		p2: {
			x: 66,
			y: 99,
			width: 42,
			height: 42,
		}
	},
	{
		url: "/img/up.png",
		p1: {
			x: 46,
			y: 103,
			width: 90,
			height: 90,
		},
		p2: {
			x: 133,
			y: 80,
			width: 100,
			height: 111,
		}
	},
	{
		url: "/img/cuevita.png",
		p1: {
			x: 77,
			y: 58,
			width: 44,
			height: 52,
		},
		p2: {
			x: 139,
			y: 48,
			width: 50,
			height: 58,
		}
	}
]

export function drawAtAngle(outputCanvas: HTMLCanvasElement, img: HTMLCanvasElement, angle: number, xPos: number, yPos: number) {
	const angleInRadians = angle * Math.PI / 180;
	var width = img.width;
	var height = img.height;

	const ctx = outputCanvas.getContext('2d');
	if (!ctx) { return }

	drawRotatedAndScaledImage(ctx, img, xPos, yPos, width*0.4, height*0.4, angleInRadians);
}

 function drawRotatedAndScaledImage(
	ctx: CanvasRenderingContext2D,
	image: CanvasImageSource,
	x: number, // Position on the canvas (X)
	y: number, // Position on the canvas (Y)
	width: number, // Desired width after scaling
	height: number, // Desired height after scaling
	angle: number // Rotation angle in radians
 ): void {
	  // Save the current context state
	  ctx.save();
 
	  // Move the canvas origin to the center of the image
	  ctx.translate(x + width / 2, y + height / 2);
 
	  // Rotate the canvas
	  ctx.rotate(angle);
 
	  // Draw the image at the new origin (adjusted for the top-left corner of the image)
	  ctx.drawImage(image, -width / 2, -height / 2, width, height);
 
	  // Restore the context to its previous state (without translation and rotation)
	  ctx.restore();
};
 
let alreadyPicked: number[] = []
export function drawRandomOutput(){
	let index = Math.floor(Math.random() * templates.length);
	while (alreadyPicked.includes(index)){
		index = Math.floor(Math.random() * templates.length);
	}
	alreadyPicked.push(index);
	if (alreadyPicked.length == templates.length){
		alreadyPicked = [];
	}
	return drawOutput(index);
}

export async function drawOutput(index: number){
	let template = templates[index];
	let canvas = await drawTemplate(template);
	let ctx = canvas.getContext('2d');
	// if (ctx) {
	// 	ctx.globalCompositeOperation = 'source-over'; // Reset to default mode
	// 	// draw polaroid like borders
	// 	ctx.fillStyle = "white";
	// 	// top border
	// 	ctx.fillRect(0, 0, canvas.width, canvas.height/10);

	// 	// bottom border
	// 	ctx.fillRect(0, canvas.height - canvas.height/7, canvas.width, canvas.height/7);

	// 	// left border
	// 	ctx.fillRect(0, 0, canvas.width/10, canvas.height);

	// 	// right border
	// 	ctx.fillRect(canvas.width - canvas.width/10, 0, canvas.width/10, canvas.height);
	// }
	return canvas;
}

export function drawTemplate(template: Template): Promise<HTMLCanvasElement> {
	return new Promise((resolve, reject) => {
	const p1Canvas = document.getElementById('p1Canvas') as HTMLCanvasElement;
	const p2Canvas = document.getElementById('p2Canvas') as HTMLCanvasElement;
	
	const outputCanvas = document.createElement('canvas') as HTMLCanvasElement;

	outputCanvas.width =  280*4;
	outputCanvas.height = 357*4;
	const img = new Image();
	img.src = template.url;
	img.onload = () => {
		if (outputCanvas && p1Canvas && p2Canvas) {
			// normalize p1 and p2 according to img size
			let p1 = { ...template.p1 };
			let p2 = { ...template.p2 };

			let widthRatio = outputCanvas.width / img.width;
			let heightRatio = 	outputCanvas.height / img.height;
			p1.x = p1.x * widthRatio;
			p1.y = p1.y * heightRatio - 50;
			p1.width = p1.width * widthRatio;

			p2.x = p2.x * widthRatio
			p2.y = p2.y * widthRatio - 50;
			p2.width = p2.width * widthRatio;


			const ctx = outputCanvas.getContext('2d');
			if (!ctx) { return }
			// person 1
			drawImageInContext(ctx, p1Canvas, p1);

			// person 2
			drawImageInContext(ctx, p2Canvas, p2);

			// change composite to avoid drawing on top
			ctx.globalCompositeOperation = 'destination-over';
			const border = 0;
			ctx.drawImage(img, border, border, outputCanvas.width-border, outputCanvas.height-border);
			resolve(outputCanvas);
		}
	}
	});
}


export function takeScreenshot(sourceEl: HTMLVideoElement | HTMLImageElement | HTMLCanvasElement, canvasEl: HTMLCanvasElement) {
	if (!sourceEl || !canvasEl) { return }
	const ctx = canvasEl.getContext('2d');
	if (ctx) {
		findFace(sourceEl, (face: Detection) => {
			if (face) {
				// crop canvas to face
				let paddingX = sourceEl.width * 0.1;
				let paddingY = sourceEl.height * 0.3;
				canvasEl.width = (face.boundingBox.width * sourceEl.width) + paddingX;
				canvasEl.height = (face.boundingBox.height * sourceEl.height) + paddingY;
				ctx.drawImage(sourceEl,
					(face.boundingBox.xCenter - face.boundingBox.width / 2) * sourceEl.width - paddingX / 2, // sx
					(face.boundingBox.yCenter - face.boundingBox.height / 2) * sourceEl.height - paddingY * 0.5, // sy
					(face.boundingBox.width * sourceEl.width) + paddingX, // width
					(face.boundingBox.height * sourceEl.height) + paddingY * 0.6,  // height
					0, 0, canvasEl.width, canvasEl.height);

				// https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
				// feed this canvas to the face segmentation
				faceSegment(canvasEl, (segmentation: GpuBuffer, image: GpuBuffer) => {
					console.log("Segmented, face", segmentation)
					ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
					// draw "mask"
					ctx.drawImage(segmentation, 0, 0, canvasEl.width, canvasEl.height);
					// draw image on top of mask
					ctx.globalCompositeOperation = 'source-in';
					ctx.drawImage(image, // height
						0, 0, canvasEl.width, canvasEl.height);
				});

			} else {
				console.log('No face detected');
			}
		});
	}
}